import React from 'react';
import WealthGapCard from '../PersonalFinancialReadiness/WealthGapCard';

class WealthGapResults extends React.Component {
  render() {
    const { user, onBack, track } = this.props;
    const goal = user?.readiness_goal_lump_sum || 0;
    const assets = user?.readiness_current_investable_assets || 0;
    const gap = user?.readiness_gap_value ?? (goal - assets);
    const zone = user?.readiness_gap_zone || 'red';

    const recommend = () => {
      if (!zone || zone === 'green') return ['Legacy Planning', 'Tax Efficiency'];
      return ['Run Valuation', 'Continuity Roadmap', 'Succession Roadmap'];
    };

    return (
      <div className="min-h-screen flex justify-center bg-succession-surface px-4 pt-4 pb-10">
        <div className="w-full max-w-3xl">
          <div className="mb-4">
            <button type="button" onClick={onBack} className="text-succession-primary hover:underline" aria-label="Go back">← Back</button>
          </div>
          <h1 className="text-3xl md:text-4xl font-semibold text-succession-foreground mb-2">Wealth Gap</h1>
          <p className="text-succession-muted mb-4">Your Wealth Gap is the difference between the money you’ll need to fund your lifestyle for life (Wealth Goal) and the investable assets you already have outside your business.</p>
          <WealthGapCard goal={goal} assets={assets} gap={gap} zone={zone} title="Wealth Gap" hideCurrencySymbol={true} hideTitle={true} />
        </div>
      </div>
    );
  }
}

export default WealthGapResults;


